module.exports = __webpack_public_path__ + "img/5.fd7c7264.png";